import { useMemo } from "react";
import { useQuery } from "react-query";
import { getPortfolioDashboardWorkspaces } from "apps/project-iq/api";
import { IProjectIQWorkspace } from "models/IProjectIQWorkspace";

export const PORTFOLIO_DASHBOARD_WORKSPACES_QUERY_KEY =
  "portfolioDashboardWorkspaces";

export interface IUsePortfolioDashboardWorkspacesParams {
  isEnabled: boolean;
}

export interface IUsePortfolioDashboardWorkspacesResult {
  workspaces: IProjectIQWorkspace[];
  isLoading: boolean;
  isRefreshing: boolean;
  isError: boolean;
}

export const usePortfolioDashboardWorkspaces = ({
  isEnabled,
}: IUsePortfolioDashboardWorkspacesParams): IUsePortfolioDashboardWorkspacesResult => {
  const { data, isLoading, isFetching, isError } = useQuery<
    IProjectIQWorkspace[],
    Error
  >({
    queryKey: [PORTFOLIO_DASHBOARD_WORKSPACES_QUERY_KEY],
    queryFn: () => getPortfolioDashboardWorkspaces(),
    enabled: isEnabled,
    refetchOnWindowFocus: false,
  });

  const workspaces = useMemo(() => data ?? [], [data]);

  return {
    workspaces,
    isLoading,
    isRefreshing: isFetching && !isLoading,
    isError,
  };
};
